"use strict";

var MILLISECONDS = 1000;
var SECONDS = 60;
var MINUTES = 60;
var HOURS = 24;

function objPropsById(obj, propName) {
  var props = {};
  Object.keys(obj).map(function (key) {
    var type = obj[key];
    props[type.id] = type[propName];
  });
  return props;
}

function mapArrayByProp(arr, key) {
  var byKey = arr.reduce(function (memo, prop, index) {
    memo[prop[key]] = prop;
    return memo;
  }, {});
  return byKey;
}

function toSeconds(_ref) {
  var _ref$days = _ref.days,
      days = _ref$days === undefined ? 0 : _ref$days,
      _ref$hours = _ref.hours,
      hours = _ref$hours === undefined ? 0 : _ref$hours,
      _ref$minutes = _ref.minutes,
      minutes = _ref$minutes === undefined ? 0 : _ref$minutes,
      _ref$seconds = _ref.seconds,
      seconds = _ref$seconds === undefined ? 0 : _ref$seconds;
  var daysS = days * HOURS * MINUTES * SECONDS;
  var hoursS = hours * MINUTES * SECONDS;
  var minutesS = minutes * SECONDS;
  var secondsS = seconds;
  var totalS = daysS + hoursS + minutesS + secondsS;
  return totalS;
}

function toMilliseconds(_ref2) {
  var _ref2$days = _ref2.days,
      days = _ref2$days === undefined ? 0 : _ref2$days,
      _ref2$hours = _ref2.hours,
      hours = _ref2$hours === undefined ? 0 : _ref2$hours,
      _ref2$minutes = _ref2.minutes,
      minutes = _ref2$minutes === undefined ? 0 : _ref2$minutes,
      _ref2$seconds = _ref2.seconds,
      seconds = _ref2$seconds === undefined ? 0 : _ref2$seconds;
  var totalMs = toSeconds({
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }) * MILLISECONDS;
  return totalMs;
}

module.exports = {
  objPropsById: objPropsById,
  toMilliseconds: toMilliseconds,
  mapArrayByProp: mapArrayByProp,
  toSeconds: toSeconds
};